import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

/* global Waypoint */
import 'waypoints/lib/noframework.waypoints.min';

gsap.registerPlugin(ScrollTrigger);


const inViewWatcher = () => {

    const indicatorWrapperElm = document.querySelectorAll('[data-process-indicator]');
    const indicatorElm = document.querySelectorAll('[data-process-indicator-inner]');

    if(indicatorWrapperElm && indicatorElm) {

        gsap.to(indicatorElm, {
            height: '100%',
            ease: 'power1.inOut',
            scrollTrigger: {
                trigger: indicatorWrapperElm,
                pin: false,
                scrub: 1,
                start: "top +=140%",
                end: "bottom +=40%",
                invalidateOnRefresh: true,
                markers: false
            }
        });
    }

    const elements = document.querySelectorAll('[data-process-item]');
    elements.forEach(element => {

        const waypoint = new Waypoint({
            element,
            handler: function(direction) {
                console.log(' triggers at ' + this.triggerPoint)
                console.log(direction);
                if(direction === 'down') {
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            },
            offset: '80%'
        })
    })
}

document.addEventListener('DOMContentLoaded', inViewWatcher, {
    once: true,
});
